import { useEffect } from 'react';
import { Analytics } from '@trello/atlassian-analytics';
import { sendErrorEvent } from '@trello/error-reporting';
import { MissingBoardStarsDataError } from './useBoardStars';
import { MissingStarredBoardsDataError } from './useStarredBoardsListPage';

export const useStarredBoardsQueryErrorHandlingEffect = (error?: Error) => {
  useEffect(() => {
    if (error) {
      if (
        error instanceof MissingBoardStarsDataError ||
        error instanceof MissingStarredBoardsDataError
      ) {
        /*
          This is an instance of the odd, known issue where our Apollo/GraphQL
          implementation returns undefined for data, error, and loading.
          Generally this happens when the user navigates to a different
          page, simply report as non-error operational event.
        */
        Analytics.sendOperationalEvent({
          action: 'attempted',
          actionSubject: 'fetchStarredBoards',
          source: 'starredBoardsMenuInlineDialog',
          attributes: {
            name: error.name,
            message: error.message,
          },
        });
      } else {
        sendErrorEvent(error, {
          tags: {
            feature: 'Starred Boards Menu Button',
            ownershipArea: 'trello-teamplates',
          },
        });
      }
    }
  }, [error]);
};
